import { TJob } from './isJob';

export default (job: Pick<TJob, 'jobFields'>): string[] => {
	const fields = job.jobFields || [];

	return fields.map((field) => field.name || '');
};
